import dataSelect from "@store/dataForSelect/reducers";

import { roles } from "../../configs/constants";

export default dataSelect(roles);
